import { css, FlattenSimpleInterpolation } from "styled-components";

import { SearchTextFieldVariant } from "./types";

export const BASE_STYLE = css`
    .MuiOutlinedInput-root {
        max-height: 40px;
        border: 1px solid transparent;

        &:focus,
        &:focus-visible,
        &.Mui-focused {
            border: 1px solid #ffdca8;
            outline: none;
        }
    }

    .MuiOutlinedInput-input {
        padding-inline: 0;
        font-size: 0.875rem;
        font-weight: 400;

        &::placeholder {
            font-family: Raleway;
            color: rgb(102, 77, 51);
        }

        &:focus-visible {
            outline: none;
        }
    }
`;

export const LIGHT_VARIANT = css`
  .MuiOutlinedInput-root {
    background: #f5dfc4;

    &.Mui-focused {
      background: #f5dfc4;
    }
  }

  .MuiOutlinedInput-input {
    color: #664d33;
  }
`;

export const DARK_VARIANT = css`
  .MuiOutlinedInput-root {
    &.Mui-focused {
      background: #f5dfc4;
      color: rgb(102, 77, 51);
    }
  }

  && .MuiOutlinedInput-input {
    color: #ffffff;
    font-weight: 400;
    font-size: 0.875rem;
    letter-spacing: 0.02em;

    &::placeholder {
      color: rgba(255, 255, 255, 0.8) !important;
      opacity: 1 !important;
      font-style: normal !important;
      font-weight: 400 !important;
      font-size: 0.875rem !important;
      letter-spacing: 0.02em !important;
      -webkit-text-fill-color: rgba(255, 255, 255, 0.8) !important;
      transition: -webkit-text-fill-color 0.2s ease, color 0.2s ease;
    }

    &:focus::placeholder {
      color: transparent !important;
      -webkit-text-fill-color: transparent !important;
    }
  }
`;

export const VARIANT_STYLE: Record<SearchTextFieldVariant, FlattenSimpleInterpolation> = {
  light: LIGHT_VARIANT,
  dark: DARK_VARIANT,
};
